import React, { useState, useEffect, useRef } from "react";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Grid,
  IconButton,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { tokens } from "../../theme";
import ModalCharge from "../../modal/modalCharge";
import ModalCamion from "../../modal/camiones/modalCamion";
import Header from "../../components/Header";
import ModalImage from "../../modal/imagen/modalImagen";
import { getOneHistorialTicket, getOneTicket, PostDatos } from "../../services/stockDeposito.services";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOneProductoDepositoView } from "../../services/amoxarifado.services";
import ModalPatrimonio from "../../modal/amoxarifado/modalPatrimonio";
import ModalSector from "../../modal/amoxarifado/modalSector";
import ModalUserData from "../../modal/user/modalUserData";
import { getApiImagen } from "../../utils/getApiBaseUrl";
import secureStorage from "../../utils/secureStorage";

const StockDeposito = () => {
  const [proveedor, setProveedor] = useState("");
  const [serviceType, setServiceType] = useState(1);
  const [products, setProducts] = useState([]);
  const [modalPatrimonio, setModalPatrimonio] = useState(false);
  const [modalSector, setModalSector] = useState(false);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [modalUserOpen, setModalUserOpen] = useState(false);
  const initialRows = [
    {
      id: 1,
      items: [{ id: "", serie: "", cantidad: "" }],
      caballet: [],
      producto: { cod: "", obs: "", cantidad: "" },
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cantidad, setCantidad] = useState(0); // Estado para guardar la información de la impresora
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [modalCamionOpen, setModalCamionOpen] = useState(false);
  const USER = secureStorage.getItem("id");
  const formikRef = useRef(null);
  const [sinNota, setSinNota] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null); // Estado para la imagen seleccionada
  const initialValues = {
    operacion: "",
    numeroNota: "",
    modelo: "",
    operacion: "",
    formaDePago: "",
    condicionPago: "",
    id_vehiculo: "",
    id_producto: "",
    operacion: "",
    cantidad: "",
    obs: "",
    cod: "",
    caballet: [{ caballete: "" }],
    cantidad2: "",
    descripcion: "",
    id_patrimonio: "",
    usuario_re: "",
  };

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    let numeroNotaFinal = values.numeroNota;
    let descripcionFinal = values.obs;
    let patrimonio = values.id_patrimonio || 0;
    let usuario_re = values.usuario_re || 0;

    if (values.operacion === "Entrada" && sinNota) {
      numeroNotaFinal = "SIN NOTA";
      patrimonio = 0;
      usuario_re = values.usuario_re || 0;

    } else if (
      values.operacion === "Salida" &&
      values.operacion === "Prestamos"
    ) {
      numeroNotaFinal = "SIN NOTA";
      patrimonio = values.id_patrimonio || "";
      usuario_re = values.usuario_re || 0;
    } else if (
      values.operacion !== "Entrada" &&
      values.operacion !== "Salida"
    ) {
      numeroNotaFinal = "SIN NOTA";
    }
    if (
      (values.operacion === "Entrada" && sinNota) ||
      values.operacion === "Salida" ||
      values.operacion === "Perdida"
    ) {
      // descripcionFinal ya está correcto desde Formik
    } else {
      descripcionFinal = "";
    }

    // 👉 Validar cantidades
    let isValid = true;
    let errorMessage = "";

    for (let i = 0; i < products.length; i++) {
      const cantidad = parseInt(products[i].cantidad, 10);

      if (isNaN(cantidad) || cantidad <= 0) {
        isValid = false;
        errorMessage = `La cantidad del producto ${
          i + 1
        } es inválida o está vacía.`;
        break;
      }
    }

    if (!isValid) {
      console.error("❌ Error en validación:", errorMessage);
      setRegistrationError(true);
      setError(errorMessage);
      setIsLoading(false);
      return;
    }

    // Validación adicional para Entrada con nota
    if (values.operacion === "Entrada" && !sinNota && !values.numeroNota) {
      setRegistrationError(true);
      setError("Debes ingresar el número de nota para una entrada.");
      setIsLoading(false);
      return;
    }

    if (values.operacion === "Entrada" && sinNota && !values.obs) {
      setRegistrationError(true);
      setError("Debes ingresar una Observacion para la entrada.");
      setIsLoading(false);
      return;
    }

    const valuesToSend = {
      data: products.map((product) => ({
        id_producto: product.producto?.id || "",
        operacion: values.operacion,
        cod: product.producto.id || "",
        deposito: product.producto?.id_deposito || "",
        estante: product.producto?.id_estante || "",
        fila: product.producto?.id_fila || "",
        columna: product.producto?.id_columna || "",
        obs: descripcionFinal,
        cantidad:
          values.operacion != "Entrada"
            ? -Math.abs(parseInt(product.cantidad) || 0)
            : parseInt(product.cantidad) || 0,
        id_usuario: parseInt(USER),
        id_nota: numeroNotaFinal || "",
        id_patrimonio: patrimonio,
        usuario_re: usuario_re,
        estado_devolucion: values.operacion === "Prestamos" ? 2 : 1, // ← Nuevo campo aquí
      })),
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const response = await PostDatos(valuesToSend);
      
      setRegistrationSuccess(true);

      // Acceder correctamente a los productos del response
      const productosParaTicket = response.results.flat();

      const resp = await getOneHistorialTicket(productosParaTicket[0].id_ticket);

      const html = generateTicketHTML(values, resp);
      const newWindow = window.open('', '_blank');
      newWindow.document.write(html);
      newWindow.document.close();
      resetForm();
      setProducts([]); // Resetear productos a los valores iniciales
    } catch (error) {
      console.error("Error al enviar los datos", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };


const generateTicketHTML = (values, productsRaw) => {
  const products = Array.isArray(productsRaw) ? productsRaw : [];
  const fecha = new Date().toLocaleString();
  const idTicket = products[0]?.id_ticket || "N/A";

  return `
    <html>
    <head>
      <style>
        @media print {
          body { margin: 0; font-size: 10px; font-family: monospace; }
        }
        body {
          font-size: 12px;
          font-family: monospace;
          padding: 10px;
        }
        .ticket {
          width: 250px;
        }
        .title {
          text-align: center;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .line {
          border-top: 1px dashed #000;
          margin: 5px 0;
        }
        .center {
          text-align: center;
          margin-top: 20px;
        }
        img {
          margin: 0 auto;
          display: block;
        }
      </style>
    </head>
    <body onload="window.print(); window.onafterprint = function() { window.close(); }">
      <div class="ticket">
        <div class="title">SALIDA DE DEPOSITO</div>
        <div>Fecha: ${fecha}</div>
        <div>Operación: ${values.operacion}</div>
        <div>Patrimonio: ${values.patrimonio}</div>
        <div class="line"></div>
        <div>Producto ------------------- Cantidad</div>
        ${products.map(p => `
          <div style="display: flex; justify-content: space-between;">
            <span>${p.producto || ""}</span>
            <span>${p.cantidad || ""}</span>
          </div>
        `).join('')}
<div style="margin-top: 40px;">
  <div style="display: flex; justify-content: space-between;">
    <div style="text-align: center;">
      _____________________<br/>
      Firma Usuario<br/>
      ${products[0]?.usuario || "Usuario"}
    </div>
    <div style="text-align: center;">
      _____________________<br/>
      Firma Responsable<br/>
      ${products[0]?.usuario_re || "Responsable"}
    </div>
  </div>
</div>

        <div class="center">


          <!-- Código QR -->
          <img 
            src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(idTicket)}" 
            alt="QR Code"
            width="100"
          />
        </div>

      </div>
    </body>
    </html>
  `;
};


  useEffect(() => {
    setServiceType(proveedor);
  }, [proveedor]);

  const handleSelectCamion = (Camion, setFieldValue) => {
    setFieldValue("id_vehiculo", Camion.id);
    setModalCamionOpen(false); // Cerrar el modal de productos
  };

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...products];

    if (field === "producto.serie") {
      updatedProducts[index].producto = {
        ...updatedProducts[index].producto,
        serie: value,
      };
    } else {
      updatedProducts[index][field] = value;
    }

    setProducts(updatedProducts);
    actualizarCantidadTotal(updatedProducts);
  };

  const handleCodigoProductoBlur = async (index) => {
    const codigo = products[index].producto?.serie;
    if (!codigo) return;

    try {
      const data = await getOneProductoDepositoView(codigo); // tu función real
      const updatedProducts = [...products];
      updatedProducts[index].producto = {
        ...data, // suponiendo que el backend devuelve el objeto completo
      };
      setProducts(updatedProducts);
    } catch (error) {
      console.error("Producto no encontrado:", error);
      toast.error("Producto no encontrado");
    }
  };

  const addProduct = () => {
    setProducts([
      ...products,
      { producto: "", cantidad: "", items: [] }, // Producto inicial
    ]);
  };

  // Eliminar un producto
  const removeProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
    actualizarCantidadTotal(updatedProducts);
  };

  const actualizarCantidadTotal = (productos) => {
    const total = productos.reduce((sum, prod) => {
      const cantidad = parseFloat(prod.cantidad);
      return sum + (isNaN(cantidad) ? 0 : cantidad);
    }, 0);
    setCantidad(total);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <Box sx={{ padding: "20px", height: "80vh", overflowY: "auto" }}>
      <Header title="Stock Deposito" subtitle="Disponibilidad Stock" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={checkoutSchema}
        validateOnChange={true}
        context={{ sinNota }}
        onSubmit={handleFormSubmit}
        innerRef={formikRef} // Utilizamos ref para evitar ciclo de actualización
      >


        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                "& .MuiOutlinedInput-root": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiOutlinedInput-root.MuiOutlinedInput-notchedOutline": {
                  border: "none",
                  background: `${colors.primary[950]} !important`,
                  borderBottom: `1px solid ${colors.grey[100]} !important`,
                },
                "& .MuiInputBase-input": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiInputLabel-root": {
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiSvgIcon-root": {
                  color: `${colors.grey[100]} !important`,
                  zIndex: 10,
                },
                "& .MuiInputLabel-root": {
                  zIndex: 200,
                  color: `${colors.grey[100]} !important`,
                },
                "& .MuiOutlinedInput-input": {
                  padding: "12px",
                  zIndex: 100,
                },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                label="Operacion"
                name="operacion"
                value={values.operacion}
                onChange={(e) => {
                  handleChange(e);
                  setSinNota(false); // Resetear switch si cambia la operación
                }}
                error={!!touched.operacion && !!errors.operacion}
                helperText={touched.operacion && errors.operacion}
                select // Esta propiedad convierte el TextField en un select
              >
                {/* Opciones del select */}
                <MenuItem value="Entrada">Entrada</MenuItem>
                <MenuItem value="Salida">Salida</MenuItem>
                <MenuItem value="Prestamos">Prestamos</MenuItem>
                <MenuItem value="Perdida">Perdida</MenuItem>
              </TextField>

              {(values.operacion === "Entrada" || values.operacion === "Salida") && (
                <>
                  {values.operacion === "Entrada" && (
                    <Box mb={2}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={sinNota}
                            onChange={() => setSinNota((prev) => !prev)}
                            color="primary"
                          />
                        }
                        label="No tiene nota"
                      />
                    </Box>
                  )}

                  {/* Si no se marcó el switch, mostrar campo de número de nota */}
                  {values.operacion === "Entrada" && !sinNota && (
                    <Box mb={2}>
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Nota Fiscal N°"
                        name="numeroNota"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.numeroNota}
                        error={!!touched.numeroNota && !!errors.numeroNota}
                        helperText={touched.numeroNota && errors.numeroNota}
                      />
                    </Box>
                  )}

                  {/* Si se marcó el switch, mostrar campo de descripción */}
                  {(values.operacion === "Salida" || sinNota) && (
                    <Box mb={2}>
                      <TextField
                        fullWidth
                        variant="filled"
                        type="text"
                        label="Descripción"
                        name="obs"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.obs}
                        error={!!touched.obs && !!errors.obs}
                        helperText={touched.obs && errors.obs}
                      />
                    </Box>
                  )}
                </>
              )}

              {/* Perdida con descripción directamente */}
              {values.operacion === "Perdida" && (
                <Box mb={2}>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Descripción"
                    name="obs"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.obs}
                    error={!!touched.obs && !!errors.obs}
                    helperText={touched.obs && errors.obs}
                  />
                </Box>
              )}

              {(values.operacion === "Salida" ||
                values.operacion === "Prestamos") && (
                <TextField
                  fullWidth
                  variant="filled"
                  label="Patrimonio"
                  name="id_patrimonio"
                  value={values.id_patrimonio}
                  onClick={() => setModalSector(true)}
                  sx={{ gridColumn: "span 1", cursor: "pointer" }}
                  error={!!touched.id_patrimonio && !!errors.id_patrimonio}
                  helperText={touched.id_patrimonio && errors.id_patrimonio}
                />
              )}

              {(values.operacion === "Salida" ||
                values.operacion === "Prestamos") && (
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Usuario"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.usuario_re}
                  name="usuario_re"
                  error={!!touched.usuario_re && !!errors.usuario_re}
                  helperText={touched.usuario_re && errors.usuario_re}
                  sx={{ gridColumn: "span 1" }}
                  onClick={() => setModalUserOpen(true)}
                />
              )}
            </Box>
            <Box
              display="flex"
              alignItems="center"
              mb={2}
              sx={{ marginTop: "1vw" }}
            >
              <IconButton color="secondary" onClick={addProduct}>
                <AddCircleIcon />
              </IconButton>
              <Typography variant="body1">Agregar Producto</Typography>
            </Box>

            {products.map((product, productIndex) => (
              <Box
                key={productIndex}
                mt={2}
                sx={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "8px",
                  paddingLeft: "1vh",
                }}
              >
                {/* Producto y Cantidad */}
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Serie"
                      value={product.producto?.serie || ""}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleCodigoProductoBlur(productIndex);
                        }
                      }}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.serie",
                          e.target.value
                        )
                      }
                      onBlur={() => handleCodigoProductoBlur(productIndex)}
                      placeholder="Ingrese código y presione Enter o salga"
                    />
                  </Grid>

                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Cantidad"
                      value={product.cantidad}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "cantidad",
                          e.target.value
                        )
                      }
                    />
                  </Grid>

                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Producto"
                      value={product.producto?.cod || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.cod",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Deposito"
                      value={product.producto?.deposito || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.deposito",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Estante"
                      value={product.producto?.estante || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.estante",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Columna "
                      value={product.producto?.columna || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.columna",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={10}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Fila"
                      value={product.producto?.fila || ""}
                      onChange={(e) =>
                        handleProductChange(
                          productIndex,
                          "producto.fila",
                          e.target.value
                        )
                      }
                    />
                  </Grid>

                  {product.producto?.imagen && (
                    <Grid item xs={10}>
                      <img
                        src={`${getApiImagen()}${product.producto?.imagen}`}
                        alt="Producto"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          marginTop: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleImageClick(
                            `${getApiImagen()}${product.producto?.imagen}`
                          )
                        }
                      />
                    </Grid>
                  )}

                  <Grid item xs={1}>
                    <IconButton
                      color="secondary"
                      onClick={() => removeProduct(productIndex)}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            ))}

            <Box
              sx={{ paddingRight: "2%", paddingTop: "3%", paddingBottom: "3%" }}
              className="wrap"
            >
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  border: "none",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  cursor: "pointer",
                  marginRight: "1vw",

                  "&:hover": { backgroundColor: "#bac609" },
                }}
              >
                Registrar
              </Button>
            </Box>

            <ModalCharge isLoading={isLoading} />
            <ModalCamion
              open={modalCamionOpen} // Estado del modal de Camions
              onClose={() => setModalCamionOpen(false)} // Cerrar el modal de Camions
              onSelectVehiculos={(Camion) =>
                handleSelectCamion(Camion, setFieldValue)
              } // Lógica para seleccionar productos
            />
            <ModalImage
              open={Boolean(selectedImage)}
              onClose={handleCloseImageModal}
              imageSrc={selectedImage}
            />

            <ModalPatrimonio
              open={modalPatrimonio}
              onClose={() => setModalPatrimonio(false)}
              onSelectPatrimonio={(patrimonio) => {
                setFieldValue("id_patrimonio", patrimonio.id);
                setFieldValue("patrimonio", patrimonio.descripcion);
                setModalPatrimonio(false);
              }}
              sector={sectorSeleccionado}
            />

            <ModalSector
              open={modalSector}
              onClose={() => setModalSector(false)}
              onSelectSector={(sector) => {
                setSectorSeleccionado(sector);
                setModalSector(false);
                setModalPatrimonio(true);
              }}
            />

            <ModalUserData
              open={modalUserOpen}
              onClose={() => setModalUserOpen(false)}
              onSelectUsuario={(user) => {
                setFieldValue("usuario_re", user.id);
                setModalUserOpen(false);
              }}
            />
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = Yup.object().shape({
  operacion: Yup.string().required("Campo requerido"),
  obs: Yup.string().when("operacion", {
    is: "Perdida",
    then: (schema) => schema.required("Debes ingresar una descripción"),
    otherwise: (schema) => schema.notRequired(),
  }),
});


export default StockDeposito;
